<script lang="ts" setup>
import { getLeaderboardHeadTitle, getLeaderboardOgImageUrl, getLeaderboardSeoContent, useLeaderboardSeo } from '#leaderboards/composables/useLeaderboardSeo'
import { useLeaderboardStore } from '#leaderboards/store/useLeaderboardStore'
import { leaderboardDocsNavItems, leaderboardMainNavItems } from '#leaderboards/utils/navItems'

useLeaderboardStore()

const { portal, appFrontEndDomain } = useRuntimeConfig().public
const route = useRoute()
const trophyIconSrc = '/icons/trophy.svg'

useHead({
  titleTemplate: title => title ? `${title} · Market Maker Leaderboards` : 'Market Maker Leaderboard',
})

const leaderboardSeo = computed(() => {
  const content = getLeaderboardSeoContent(route.path)
  if (!content) {
    return null
  }

  return {
    title: content.title,
    description: content.description,
    image: getLeaderboardOgImageUrl(String(appFrontEndDomain)),
  }
})

const leaderboardHeadTitle = computed(() => getLeaderboardHeadTitle(route.path) ?? 'Market Maker Leaderboard')

if (portal === 'liquidity') {
  useLeaderboardSeo(
    () => leaderboardSeo.value?.title,
    () => leaderboardSeo.value?.description,
  )
}
</script>

<template>
  <template v-if="portal === 'liquidity'">
    <NuxtLayout name="dashboard" container-layout="fluid">
      <template #header>
        <div class="flex gap-2 items-center">
          <img :src="trophyIconSrc" alt="" class="h-[32px]">
          <div class="text-sm font-semibold shrink-0">
            Market Maker Leaderboard
          </div>
        </div>
      </template>

      <template #subheader>
        <LLeaderboardNavTabs :items="leaderboardMainNavItems" :docs-items="leaderboardDocsNavItems" />
      </template>

      <template #footer>
        <LLeaderboardInviteFooter />
      </template>

      <div class="mx-auto flex w-full min-w-0 max-w-[1200px] flex-col gap-6 px-4 pt-5 mb-10 md:px-5 md:pt-6">
        <slot />
        <LGlobalFilter />
        <LMarketMakerDetails />
      </div>
    </NuxtLayout>
  </template>

  <template v-else>
    <NuxtLoadingIndicator />
    <NuxtLayout
      name="public"
      :title="leaderboardHeadTitle"
      icon-class="i-heroicons-trophy"
      :seo="leaderboardSeo ?? undefined"
      :page-header="{ description: 'Research & Insights', title: 'Market Maker Leaderboard', icon: '/icons/market-maker-leaderboards.svg' }"
    >
      <template #subheader>
        <LLeaderboardNavTabs :items="leaderboardMainNavItems" :docs-items="leaderboardDocsNavItems" />
      </template>
      <template #footer>
        <CoreAppFooterBlock />
      </template>
      <div class="mx-auto flex w-full min-w-0 max-w-[1200px] flex-col gap-6 px-4 pt-5 md:px-5 md:pt-6">
        <slot />
        <LGlobalFilter />
        <LMarketMakerDetails />
        <ReadyToStart />
      </div>
    </NuxtLayout>
  </template>
</template>
